import _extends from "@babel/runtime/helpers/extends";
import { SearchRecommendationLayout } from '@wix/domains-search-suite';
import React from 'react';
import s from './Base44Label.scss';
export const Base44Label = props => /*#__PURE__*/React.createElement(SearchRecommendationLayout.Label, _extends({}, props, {
  className: s.base44Label
}));
export const base44MainCardBadgeClassNames = {
  primary: s.base44Label,
  secondary: `${s.base44Label} ${s.secondaryCard}`
};
//# sourceMappingURL=Base44Label.js.map